import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import GavelIcon from '@mui/icons-material/Gavel'
import HandshakeIcon from '@mui/icons-material/Handshake'
import SettingsIcon from '@mui/icons-material/Settings'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeCallCenterAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeCallCenterAdminCommon'
import { routeBackOfficeGameAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeGameAdminCommon'
import { routeBackOfficeOrdersAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeOrdersAdminCommon.ts'
import { routeBackOfficeStudentAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeStudentAdminCommon'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getBackOfficeGroupSuperAdmin = [
  {
    route: 'editBanner',
    text: 'Editer',
    href: '/backoffice/group/banner/edit-banner/[bannerId]',
  },
  {
    route: 'editGroupement',
    text: 'Editer',
    href: '/backoffice/group/groupement/edit-groupement/[groupementId]',
  },
  {
    route: 'addCrmTaskTag',
    text: 'Ajouter',
    href: '/backoffice/group/crm-task-tag/add-crm-task-tag',
  },
  {
    route: 'editCrmTaskTag',
    text: 'Ajouter',
    href: '/backoffice/group/crm-task-tag/edit-crm-task-tag/[crmTaskTagId]',
  },
  {
    route: 'Settings',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Paramétrage',
    icon: SettingsIcon,
    href: '/backoffice/common/settings',
    menuHeader: true,
    position: 910,
  },
  {
    route: 'LegalDocuments',
    // Route venue de develop : rattachee a la section « Outils » du menu v2.
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Documents légaux',
    icon: GavelIcon,
    href: '/backoffice/group/legal-documents',
    menuHeader: true,
    position: 940,
  },
  {
    route: 'conditionCommercial',
    menuGroup: MENU_GROUPS.MONITORING,
    text: 'Conditions commerciales',
    icon: HandshakeIcon,
    href: '/backoffice/group/condition-commercial',
    menuHeader: true,
    position: 320,
  },
  {
    route: 'AdminList',
    // Deplace « Annuaires » -> « Gestion RH » (demande admin 2026-08-23).
    menuGroup: MENU_GROUPS.RH,
    text: 'Liste des administrateurs',
    icon: AdminPanelSettingsIcon,
    href: '/backoffice/group/user-admin',
    menuHeader: true,
    position: 180,
  },
  {
    // Referentiel des SERVICES internes + rattachement des admins (Gestion RH, 23/08).
    route: 'AdminServices',
    menuGroup: MENU_GROUPS.RH,
    text: 'Services',
    icon: AccountTreeIcon,
    href: '/backoffice/group/admin-services',
    menuHeader: true,
    position: 182,
  },
  {
    route: 'addUserAdmin',
    text: 'Ajouter un administrateur',
    href: '/backoffice/group/user-admin/add-user-admin',
    menuHeader: false,
  },
  {
    route: 'editUserAdmin',
    text: 'Editer un administrateur',
    href: '/backoffice/group/user-admin/edit-user-admin/[userId]',
    menuHeader: false,
  },
  {
    route: 'UserExternalList',
    text: 'List des comptes externes',
    href: '/backoffice/group/user-external',
    menuHeader: false,
  },
  {
    route: 'addBanner',
    text: 'Ajouter',
    href: '/backoffice/group/banner/add-banner',
  },
  {
    route: 'addGroupement',
    text: 'Ajouter',
    href: '/backoffice/group/groupement/add-groupement',
  },

  {
    route: 'addCrmTask',
    text: 'Ajouter',
    href: '/backoffice/group/crm-task/add-crm-task',
  },
  ...routeBackOfficeCallCenterAdminCommon,
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeBackOfficeStudentAdminCommon,
  ...routeBackOfficeOrdersAdminCommon,
  ...routeBackOfficeGameAdminCommon,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN],
}))

export default getBackOfficeGroupSuperAdmin
